import '@glideapps/glide-data-grid/dist/index.css';
import React from 'react';
import { ChakraProvider, CSSReset, ColorModeScript} from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from './themes/RC_Colors';
import MainLayout from './views/layouts/MainLayout';
import AppRouter from './Routing/AppRouter';
import NavigationDrawer from './views/layouts/MainLayout/NavigationDrawer';
import { UserProvider } from './Context/User';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux'; 
import store from './redux/store'; 


// Create a new QueryClient instance
const queryClient = new QueryClient();

function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <UserProvider msalInstance={msalInstance}>
        <Provider store={store}> 
          <ChakraProvider theme={theme}>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />

            <CSSReset />
            <Router>
              <QueryClientProvider client={queryClient}>
                <MainLayout drawer={<NavigationDrawer />}>
                  <AppRouter />
                </MainLayout>
                <ToastContainer />
              </QueryClientProvider>
            </Router>
          </ChakraProvider>
        </Provider>
      </UserProvider>
    </MsalProvider>
  );
}

export default App;